import OrderSetting from '@/pages/OrderSettings/OrderSetting'
import type { RouteConfig } from '@/types/routestypes'

const OrderSettingsRoute: RouteConfig = {
    path: "OrderSettings",
    element: <OrderSetting />,
    pageName: "Order Settings",
    sidebar: { show: true, icon: "" },
    permission: ["OrderSettings"],
}

export default OrderSettingsRoute